export default __webpack_public_path__ + "7b06a1cf8a6f548d0da0feb59f6f09a6.png";